import { color } from "emoreg/const";

export const checkboxColor = {
  grey: { borderColor: color.grey.base },
  blue: { borderColor: color.blue.base },
};
